<template>
    <div id="app" @click="closeAllAttr()">
        <div v-if="showTopHeader">
            <pcNav ref="pcNav"></pcNav>
        </div>
        <div v-if="isShow">
            <pc-header></pc-header>
            <commonNav ref="commonNav"></commonNav>
        </div>
        <div :class="[!isHome ? 'page-body' : '']">
            <router-view v-cloak></router-view>
        </div>
        <pc-footer v-show='showFooter'></pc-footer>
        <!-- 返回顶部 -->
        <div class="left-nav main-page">
            <transition name="el-fade-in-linear">
                <ul class="first-nav-ul" v-show="leftNavShow">
                    <li @click="goTop">
                        <span title="回到顶部" style="font-size: 20px;"><i class="el-icon-arrow-up"></i></span>
                    </li>
                    <li @click="loadPage('user-center')">
                        <span title="个人中心">
                            <img src="/image/img/user_center.png" alt="">
                        </span>
                    </li>
                </ul>
            </transition>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import pcHeader from 'components/layout/header'
    import pcFooter from 'components/layout/footer'
    import pcNav from 'components/layout/top-nav'
    import commonNav from 'components/layout/nav'

    export default {
        data() {
            return {
                isHome: false,
                showFooter: true,
                showTopHeader: true,
                leftNavShow: false,
                isShow: true,
                routes: ['/cart', '/order']
            }
        },
        components: {
            pcHeader,
            pcFooter,
            pcNav,
            commonNav
        },
        watch: {
            '$route': 'rs'
        },
        mounted() {
            this.$store.commit('setHostCode', window.location.hostname)
            this.$pcBus.$off('getUserInfo')
            this.$pcBus.$on('getUserInfo', () => {
                this.getUserInfo()
            })
            this.$pcBus.$off('getAllCart')
            this.$pcBus.$on('getAllCart', () => {
                this.getAllCart()
            })
            window.addEventListener('scroll', this.addScroll)
        },
        methods: {
            closeAllAttr() {
                this.$pcBus.$emit('closeAllAttr')
            },
            rs() {
                this.isHome = this.$route.fullPath === '/index' || this.$route.fullPath === '/login'
                this.showFooter = !this.$route.meta.hideMainFooter
                if (this.$route.fullPath === '/login' || this.$route.fullPath === '/regist' || this.$route.fullPath === '/forgetPwd') {
                    this.isShow = false
                    this.showTopHeader = false
                    this.showFooter = false
                }
                if (this.showTopHeader) {
                    this.$nextTick(() => {
                        this.$refs.pcNav.getAdviceList()
                    })
                }
                if (this.isShow) {
                    this.$nextTick(() => {
                        this.$refs.commonNav.getBackstageList()
                    })
                }
            },
            // 加载登录信息
            getUserInfo() {
                this.ajax({
                    url: `/userInfo`,
                    success: (res) => {
                        this.$store.commit('setUserInfo', res.result.user)
                    }
                })
            },
            // 加载购物车信息
            getAllCart() {
                this.loading = true
                new Promise((resolve, reject) => {
                    this.ajax({
                        url: `/cartItem/conditions`,
                        type: 'POST',
                        data: {
                            page: 1,
                            limit: 1000
                        },
                        success: (res) => {
                            if (res.result) {
                                res.result.records.forEach(item => {
                                    if (item.skuComposeList) {
                                        item.skuComposeList.forEach(item1 => {
                                            if (item1.sku.id === item.skuId) {
                                                var attrValue = item1.attrDetailsList.map(item2 => {
                                                    return item2.formatValue
                                                })
                                                item.specifications = attrValue ? attrValue.join() : []
                                            }
                                        })
                                    }
                                    item.checked = false
                                    this.$set(item, 'speShow', false)
                                    if (item.skuCompose.channelAttribute) {
                                        item.skuCompose.channelAttribute.salePrice = this.getRealPrice(item.skuCompose.priceLeverList, item.skuCompose.channelAttribute.salePrice)
                                        item.checked = false
                                    }
                                    item.itemArr1 = item.skuCompose.attrDetailsList ? item.skuCompose.attrDetailsList : []
                                })
                                this.$store.dispatch('setCartList', res.result.records)
                                resolve()
                            } else {
                                this.$store.dispatch('setCartList', [])
                                resolve()
                            }
                        }
                    })
                })
            },
            // 添加滚动事件
            addScroll(e) {
                // 滚动条的高度
                var scrollTop = document.body.scrollTop || document.documentElement.scrollTop // 滚动条在Y轴上的滚动距离
                this.leftNavShow = scrollTop > 200
            },
            // 回到顶部
            goTop() {
                window.scrollTo(0, 0)
            },
            // 个人中心
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss">
    /*import 引入的css中无效 在link引入的生效*/
    [v-cloak] {
        display: none !important
    }
    .page-body{
        margin: 0 auto;
    }
    // /deep/ .el-loading-spinner {
    //     z-index: 999;
    // }
    ::v-deep .el-loading-spinner {
        z-index: 999;
    }
    .main-page.left-nav{
        width: 50px;
        position: fixed;
        z-index: 1000;
        right: 2%;
        top: 80%;
    }
    .main-page.left-nav .first-nav-ul{
        text-align: center;
    }
    .main-page.left-nav .first-nav-ul li{
        width: 50px;
        height: 50px;
        line-height: 48px;
        border-radius: 50%;
        box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.2);
        margin-bottom: 10px;
        cursor: pointer;
        position: relative;
    }
    .main-page.left-nav .first-nav-ul li img{
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
    .main-page.left-nav .first-nav-ul > li:nth-child(1):hover{
        background: #BC5BA7;
        color: white;
    }
    .main-page.left-nav .first-nav-ul > li:nth-child(2),
    .main-page.left-nav .first-nav-ul > li:nth-child(3){
        background: #474a4c;
        color: #ffffff
    }
    
    @import './assets/styles/index.css';
</style>



// WEBPACK FOOTER //
// src/App.vue